/*
 * @Description: 路由/首次进入验证码页，前端自校验通过后跳转目标页
 */
import { useState, useRef, useEffect, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Input, Button, message } from "antd";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import "./index.less";

const CAPTCHA_LEN = 4;
const CHARS = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";

function randomCode(len) {
  let s = "";
  for (let i = 0; i < len; i++) s += CHARS[Math.floor(Math.random() * CHARS.length)];
  return s;
}
// 生成随机颜色
function randomColor(alpha = 1) {
  const r = Math.floor(Math.random() * 256)
  const g = Math.floor(Math.random() * 256)
  const b = Math.floor(Math.random() * 256)
  return alpha === 1 ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${alpha})`
}

function drawCaptcha(canvas, text) {
  if (!canvas || !text) return;
  const ctx = canvas.getContext("2d");
  const w = canvas.width;
  const h = canvas.height;
  ctx.fillStyle = "#e8eaed";
  ctx.fillRect(0, 0, w, h);
  // 干扰线（数量增多）
  for (let i = 0; i < 16; i++) {
    ctx.strokeStyle = randomColor(0.5)
    ctx.lineWidth = Math.random() * 2 + 1
    ctx.beginPath();
    ctx.moveTo(Math.random() * w, Math.random() * h);
    ctx.lineTo(Math.random() * w, Math.random() * h);
    ctx.stroke();
  }
  // 噪点（数量增多）
  for (let i = 0; i < 120; i++) {
    ctx.fillStyle = `rgba(0,0,0,${0.08 + Math.random() * 0.22})`;
    ctx.fillRect(Math.random() * w, Math.random() * h, 1.2, 1.2);
  }
  ctx.font = 'bold 24px Arial'
  const xStep = (w - 24) / text.length;
  for (let i = 0; i < text.length; i++) {
    ctx.save();
    ctx.fillStyle = `hsl(${200 + Math.random() * 40}, 45%, 28%)`;
    const x = 14 + i * xStep + xStep / 2;
    const y = h / 2 + 6;
    ctx.translate(x, y);
    ctx.rotate((Math.random() - 0.5) * 0.5);
    ctx.shadowColor = 'rgba(0,0,0,0.5)'
    ctx.shadowOffsetX = Math.random() * 3 - 1.5
    ctx.shadowOffsetY = Math.random() * 3 - 1.5
    ctx.shadowBlur = 3
    // 描边制造模糊感
    ctx.strokeStyle = "rgba(0,0,0,0.15)";
    ctx.lineWidth = 2;
    ctx.strokeText(text[i], -7, 0);
    ctx.fillText(text[i], -7, 0);
    ctx.restore();
  }
  // 二次噪点覆盖（浅色点）
  for (let i = 0; i < 55; i++) {
    ctx.fillStyle = `rgba(255,255,255,${0.25 + Math.random() * 0.45})`;
    ctx.fillRect(Math.random() * w, Math.random() * h, 1.8, 1.8);
  }
}


export default function VerifyCaptcha() {
  const history = useHistory();
  const location = useLocation();
  const from = (location.state && location.state.from) || "/home";
  const [code, setCode] = useState("");
  const [inputVal, setInputVal] = useState("");
  const [err, setErr] = useState("");
  const canvasRef = useRef(null);

  const refresh = useCallback(() => {
    const next = randomCode(CAPTCHA_LEN);
    setCode(next);
    setInputVal("");
    setErr("");
    setTimeout(() => drawCaptcha(canvasRef.current, next), 50);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const handleSubmit = () => {
    const v = (inputVal || "").trim().toUpperCase();
    if (!v) {
      setErr("请输入验证码");
      return;
    }
    if (v !== code.toUpperCase()) {
      setErr("验证码错误");
      refresh();
      return;
    }
    setErr("");
    try {
      sessionStorage.setItem("captcha_verified_path", from);
    } catch (e) {}
    message.success("验证通过");
    history.replace(from);
  };

  return (
    <div className="verify-captcha-page">
      <div className="verify-captcha-card">
        <div className="verify-captcha-head">
          <SafetyCertificateOutlined className="verify-captcha-icon" />
          <h1>安全验证</h1>
          <p>请输入下方验证码后继续访问</p>
        </div>
        <div className="verify-captcha-body">
          <div className="verify-captcha-img-wrap">
            <canvas
              ref={canvasRef}
              width={160}
              height={48}
              className="verify-captcha-canvas verify-captcha-canvas-blur"
              title="验证码"
            />
            <button
              type="button"
              className="verify-captcha-refresh"
              onClick={refresh}
              title="换一张"
            >
              换一张
            </button>
          </div>
          <div className="verify-captcha-input-wrap">
            <Input
              placeholder="请输入验证码"
              value={inputVal}
              onChange={(e) => {
                setInputVal(e.target.value);
                setErr("");
              }}
              onPressEnter={handleSubmit}
              maxLength={CAPTCHA_LEN}
              size="large"
              className="verify-captcha-input"
              autoComplete="off"
            />
          </div>
          {err && <div className="verify-captcha-err">{err}</div>}
          <Button
            type="primary"
            size="large"
            block
            className="verify-captcha-btn"
            onClick={handleSubmit}
          >
            确认
          </Button>
        </div>
      </div>
    </div>
  );
}
